import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';

import '@fontsource-variable/inter';

import App from './App';
import { registerPwa } from './pwa';
import './styles/index.css';

registerPwa();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1, staleTime: 30_000 },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster position="top-center" toastOptions={{ duration: 3500, style: { fontSize: '14px', borderRadius: '10px' } }} />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
